import { RouteObject } from 'react-router-dom';

import { Subscriptions } from './Subscriptions';

export const subscriptionsRoute: RouteObject = {
  path: 'subscriptions',
  element: <Subscriptions />,
};
